import useStateQueryParams from './useStateQueryParams';
import useTokenQueryParam from './useTokenQueryParam';

export default function useEntrypoint() {
  useStateQueryParams();
  useTokenQueryParam();

  return {};
}
